// extracted by mini-css-extract-plugin
module.exports = {"select":"h303u-o5Y9JNsF5ff-VUg"};